import { OffersMigrationAlert } from '@client/new/components/OffersMigrationAlert';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './OtpsMigrationAlert.css';

type OtpsMigrationAlertProps = {
  visible: boolean;
};

export const OtpsMigrationAlert = ({ visible }: OtpsMigrationAlertProps) => (
  <OffersMigrationAlert
    visible={visible}
    dismissKey="otpsMigrationAlertDismissed"
    wrapperClassName={styles.spacing}
    body={
      <Typography
        variant="body"
        size="medium"
        fontWeight="normal"
        color="N-100"
      >
        Your existing links and landing pages will still work, no need to change
        anything. You can grab new links here and visit the Pricing and
        Packaging tab on Program view to quickly see which Offers a Program is a
        part of.
      </Typography>
    }
  />
);
